import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

export default function useSessionAuth() {
  const { session, isLoading, isSessionAuthenticated } = useSelector(
    (state) => state.authJwt
  );

  return {
    isLoading: isLoading,
    isSessionAuthenticated: isSessionAuthenticated,
    session: session
  };
}
